/* eslint-disable unused-imports/no-unused-vars */
import axios from '@axios'

export default {
    namespaced: true,
    state: {
        divisiones: [],
        documentos: [],
        SRI: [],
        sriXml: [],
        puntosEmision: [],
        motivosGuiaR: [],
    },
    getters: {
        getDivisionesData(state) {
            return state.divisiones
        },
        getDocumentosData(state) {
            return state.documentos
        },
        getA06T1(state) {
            return state.SRI
        },
        getSriXml(state) {
            return state.sriXml
        },
        getPuntosEmision(state) {
            return state.puntosEmision
        },
        getClaveAcceso(state) {
            return state.claveAcceso
        },
        getMotivosGuiaR(state) {
            return state.motivosGuiaR
        },
    },
    mutations: {
        SET_DIVISIONES(state, divisiones) {
            state.divisiones = divisiones
        },
        SET_DOCUMENTOS(state, documentos) {
            state.documentos = documentos
        },
        SET_A06T1(state, SRI) {
            state.SRI = SRI
        },

        SET_PAGES(state, current_page) {
            state.current_page = current_page
        },
        SET_TOTAL_PAGES(state, last_page) {
            state.last_page = last_page
        },
        SET_PER_PAGE(state, per_page) {
            state.per_page = per_page
        },
        SET_TOTAL(state, total) {
            state.total = total
        },
        SET_AGREGAR(state, data) {
            const detalle = state.SRI.push(data)
        },
        SET_ESTADO(state, documentoId) {
            const detalle = state.SRI.find(p => p.id === documentoId)
            detalle.estado = 0
            const indice = state.SRI.indexOf(detalle)
            state.SRI.splice(indice, 1)
        },
        setSriXml(state, sriXml) {
            state.sriXml = sriXml
        },
        setPuntosEmision(state, puntosEmision) {
            state.puntosEmision = puntosEmision
        },
        setGuiaRemision(state, guiasRemision) {
            state.guiasRemision = guiasRemision
        },
        setClaveAcceso(state, claveAcceso) {
            state.claveAcceso = claveAcceso
        },
        setMotivoGuiaR(state, motivosGuiaR) {
            state.motivosGuiaR = motivosGuiaR
        },
    },
    actions: {
        fetchMotivoGuiaRemision({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sri/motivosGuiaRemision', { params: data })
                    .then(response => {
                        commit('setMotivoGuiaR', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGuiaRemision({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sri/guiaRemision', { params: data })
                    .then(response => {
                        commit('setGuiaRemision', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAprobacionMasivaGuia({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sri/aprobarGuiaMasivo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchValidarMasivaXml({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sri/validarXmlMasivo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchClaveAcceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sri/claveAcceso', { params: data })
                    .then(response => {
                        commit('setClaveAcceso', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        generarDocumentoElectronico({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sri/generar-documento-electronico', data)
                    .then(response => {
                        // commit('setClaveAcceso', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPuntoEmisionTipo({ commit }, tipo_comprobante) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sri/puntoEmision/' + tipo_comprobante)
                    .then(response => {
                        commit('setPuntosEmision', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAprobarGuiaR({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sri/aprobarGuiaR', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        verificarClaveAccesoGR({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sri/verificarClaveAccesoGR', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAprobarGuiaEmbarque({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sri/aprobarGuiaEmbarque', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEditarGuiaR({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sri/editarGuiaR', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateGuiaRemision({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sri/updateGuiaRemision', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUser({ commit }, userId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/sri/editarA06T1/${userId}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDivisiones({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sri/divisiones')
                    .then(response => {
                        commit('SET_DIVISIONES', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDocumentos({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sri/documentos')
                    .then(response => {
                        commit('SET_DOCUMENTOS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postA06t1({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sri/agregarA06T1', data)
                    .then(response => {
                        //commit('SET_AGREGAR', data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEditA06t1({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/api/auth/sri/editarA06T1', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        deleteA06T1({ commit }, documentoId) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sri/eliminarA06T1', { documentoId: documentoId })
                    .then(response => {
                        commit('SET_ESTADO', documentoId)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchA06T1({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sri', { params: data })
                    .then(response => {
                        commit('SET_A06T1', response.data.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchValidarXml({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sri/validarXml', { params: data })
                    .then(response => {
                        commit('setSriXml', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateFirmaComprobanteElectronico({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sri/createFirmaComprobanteElectronico', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCreateComprobanteElectronico({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sri/createComprobanteElectronico', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        //actualizaciones de SRI
        postA01533({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sri/agregarA01533', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //SRI Proveedor
        postA01532({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sri/agregarA01532', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchActualizarClave({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sri/actualizarClave', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchLoadGuiaRemisionEdit({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sri/loadGuiaRemisonEdit', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchLoadPistoleos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sri/loadPistoleos', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
